export default "__VITE_ASSET__C$bOfQWS__"